// extracted by mini-css-extract-plugin
export default {"wrapper":"NewEditor_wrapper__3gFen","flex":"NewEditor_flex__jbb9c"};